<template>
  <div>
    <el-card>
      <el-alert
    title="第三方应用"
    type="warning"
    description="请勿随意改动!改数据需要与企业微信服务商一一对应!"
    show-icon>
  </el-alert>
    </el-card>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-button-group>
          <el-button type="primary" icon="plus" @click="editConfig(null)" >添加企业微信</el-button>
        </el-button-group>
      </el-col>
    </el-row>
    <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
      <el-table-column prop="title" label="应用名称"> </el-table-column>
      <el-table-column prop="suite_id" label="应用id"> </el-table-column>
      <el-table-column prop="type" label="类型">
         <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == '1'" >小程序</el-tag>
            <el-tag type="info" v-else >网页</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="suite_secret" label="应用密钥"> </el-table-column>
      <el-table-column prop="token" label="token"></el-table-column>
      <el-table-column prop="encoding_aes_key" label="encoding_aes_key"> </el-table-column>
      <el-table-column prop="create_time" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="update_time" label="修改时间">
        <template slot-scope="scope">
          <span>{{scope.row.update_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column  label="操作：">
        <template slot-scope="scope">
          <el-button type="text" @click="editConfig(scope.row)">编辑</el-button>
          <el-button type="text" @click="deleteCard(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加 修改 -->
    <el-dialog :title="editTitle" :visible.sync="editVisible"  :before-close="handleEdit">
      <template>
        <el-form ref="form" :model="qyconfigForm" class="demo-ruleForm" label-width="120px">
          <el-form-item label="应用名称">
            <el-input v-model="qyconfigForm.title" placeholder="应用名称"></el-input>
          </el-form-item>
          <el-form-item label="应用id">
            <el-input v-model="qyconfigForm.suite_id" placeholder="应用id"></el-input>
          </el-form-item>
           <el-form-item label="类型">
            <el-input v-model="qyconfigForm.type" placeholder="0=网页应用,1=小程序"></el-input>
          </el-form-item>
          <el-form-item label="应用密钥">
            <el-input v-model="qyconfigForm.suite_secret" placeholder="应用密钥"></el-input>
          </el-form-item>
          <el-form-item label="token">
            <el-input v-model="qyconfigForm.token" placeholder="token"></el-input>
          </el-form-item>
          <el-form-item label="加密串">
            <el-input v-model="qyconfigForm.encoding_aes_key" placeholder="加密串"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAction" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {addThirdConfig,getThirdList ,editThirdConfig,deleteThirdConfig} from '../../api/workwx'
  export default {
    data () {
      return {
        loading: false,
        editVisible:false,
        submitLoading:false,
        editTitle: '',
        eidttype:'',
        qyconfigForm: {
          title: '',
          suite_id: '',
          type: '',
          suite_secret: '',
          token:'',
          encoding_aes_key: ''
        },
        templateList: [],
        list: []
      }
    },
    methods: {
      getWorkList () {
        this.loading = true
        getThirdList().then(response => {
          this.list = response.data.data.list
          this.loading = false
        })
      },
      editConfig(row){
        this.editVisible = true
        if(row){
          this.editTitle = "编辑企业微信"
          this.qyconfigForm.id = row.id
          this.qyconfigForm.title = row.title
          this.qyconfigForm.suite_id = row.suite_id
          this.qyconfigForm.type = row.type
          this.qyconfigForm.suite_secret = row.suite_secret
          this.qyconfigForm.token = row.token
          this.qyconfigForm.contact_secret = row.contact_secret
          this.qyconfigForm.encoding_aes_key = row.encoding_aes_key

        }else{
          this.configFormempty()
          this.editTitle = "添加企业微信"
          this.eidttype = 'add'
        }

      },
      configFormempty(){
        this.qyconfigForm.title = ''
        this.qyconfigForm.suite_id = ''
        this.qyconfigForm.type = ''
        this.qyconfigForm.suite_secret = ''
        this.qyconfigForm.token = ''
        this.qyconfigForm.contact_secret = ''
        this.qyconfigForm.encoding_aes_key = ''
      },
      submitAction(){
        this.submitLoading = true
        if(this.eidttype=='add'){
          addThirdConfig(this.qyconfigForm).then(res=>{
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
              this.getWorkList()
              this.editVisible = false
            }
          })
        }else{
          editThirdConfig(this.qyconfigForm.id,this.qyconfigForm).then(res=>{
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '编辑成功'
              })
              this.getWorkList()
              this.editVisible = false
            }
          })
        }
      },
      deleteCard (id, index) {
            this.$confirm('确定要删除该应用？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        deleteThirdConfig(id).then( res => {
                          if (res.data.data.status) {
                             this.$message({
                              type: 'success',
                              message: '删除成功'
                            })
                            this.list.splice(index, 1)
                            this.getWorkList()
                          }
                        })
                    }
                    done()
                }
            })
        },
      handleEdit(){
        this.editVisible = false
        this.editTitle = ""
      }
    },
    mounted () {
      this.getWorkList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 10px;
    .frm-tips {
      color: #8d8d8d;
    }
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .wxa-select {
    padding: 0 25px 25px;
  }
  .webchat-box {
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// thirdapp.vue?b6c575da